import numberToColor from "../../utils/numberToColor";
/** Dom渲染器, 用于创建弹幕DOM元素 */
var DomRenderer = /** @class */ (function () {
    function DomRenderer(stageSize) {
        this.stageSize = stageSize || [1920, 1080];
    }
    /** 创建弹幕DOM元素 */
    DomRenderer.prototype.createDom = function (dan) {
        var danmaku = dan.danmaku;
        // 创建容器元素
        var container = document.createElement("div");
        container.classList.add("pos-danmaku-item", "pos-danmaku-item-".concat(dan.rid));
        container.setAttribute("data-id", String(dan.id));
        container.setAttribute("r-id", dan.rid);
        container.style.position = "absolute";
        container.style.display = "inline-block";
        container.style.transformOrigin = "left top";
        // 创建内容元素
        var content = document.createElement("div");
        content.classList.add("pos-danmaku-item-content");
        content.innerHTML = danmaku.content;
        content.style.whiteSpace = "pre";
        content.style.transform = danmaku.anchor ? "translate(".concat(-danmaku.anchor[0] * 100, "%, ").concat(-danmaku.anchor[1] * 100, "%)") : "";
        // 设置基本样式
        content.style.fontSize = this.setRelativeSize(danmaku.size, danmaku.relative) + "px";
        content.style.color = this.getColorString(danmaku.color);
        content.style.fontWeight = danmaku.bold ? "700" : "400";
        content.style.fontFamily = danmaku.font || "SimHei";
        content.style.textShadow = danmaku.shadow ? "".concat(this.setRelativeSize(danmaku.shadow[1], danmaku.relative), "px ").concat(this.setRelativeSize(danmaku.shadow[2], danmaku.relative), "px ").concat(this.setRelativeSize(danmaku.shadow[3], danmaku.relative), "px ").concat(this.getColorString(danmaku.shadow[0]), " ") : "";
        content.style.webkitTextStroke = danmaku.stroke ? "".concat(this.setRelativeSize(danmaku.stroke[1], danmaku.relative), "px ").concat(this.getColorString(danmaku.stroke[0])) : "";
        container.appendChild(content);
        return container;
    };
    /** 根据相对屏幕宽度设置值 */
    DomRenderer.prototype.setRelativeSize = function (value, relative) {
        return value ? value / (relative || 800) * this.stageSize[0] : 0;
    };
    DomRenderer.prototype.getColorString = function (value) {
        if (typeof value == "number") {
            return numberToColor(value);
        }
        else {
            return value;
        }
    };
    return DomRenderer;
}());
export { DomRenderer };
//# sourceMappingURL=DomRenderer.js.map